import { gql } from "@apollo/client";

export const GET_ACADEMIC_YEAR_FOR_SELECT = gql`
query GetAcademicYearsForSelect {
  getAcademicYearsForSelect {
    _id
    status
    endDate
    startDate
    academicYearTitle
  }
}
`;

export const GET_PROGRAMME_FOR_SELECT = gql`
  query GetProgrammesForSelect {
    getProgrammesForSelect {
      _id
      programmeName
    }
  }
`;

export const GET_CLASS_GROUP_BY_PROGRAMME_FOR_SELECT = gql`
  query GetClassGroupsByProgrammeForSelect($programme: ID) {
    getClassGroupsByProgrammeForSelect(programme: $programme) {
      _id
      classGroupName
    }
  }
`;

export const GET_SHIFT_FOR_SELECT = gql`
  query GetShiftsForSelect {
    getShiftsForSelect {
      _id
      shiftName
    }
  }
`;

export const GET_INCOME_HEAD_FOR_SELECT = gql`
  query GetIncomeHeadForSelect {
    getIncomeHeadForSelect {
      _id
      incomeName
    }
  }
`;

export const GET_CHART_OF_ACCOUNT_FOR_SELECT = gql`
  query GetChartOfAccountForSelect {
    getChartOfAccountForSelect {
      _id
      chartOfAccount
      code_account
    }
  }
`;

export const GET_ACTIVE_ACADEMIC_YEAR = gql`
  query GetActiveAcademicYear {
    getActiveAcademicYear {
      _id
      academicYearName
      academicYearKhName
    }
  }
`;

export const GET_BILL_TO_STUDENT = gql`
  query GetBillTo($studentId: ID!) {
    getBillTo(studentId: $studentId) {
      _id
      bill_name
    }
  }
`;

export const GET_ENROLLMENT_BY_STUDENT = gql`
  query GetEnrollmentsByStudent($studentId: ID!, $academicYearId: ID!) {
    getEnrollmentsByStudent(
      studentId: $studentId
      academicYearId: $academicYearId
    ) {
      _id
      className
      shiftName
    }
  }
`;

export const GET_ADDITIONALFEE_SELECT = gql`
  query GetAdditionalFees {
    getAdditionalFees {
      _id
      feeName
      price
    }
  }
`;

export const GET_CLASS_BY_ACADEMIC_YEAR = gql`
  query GetClassesByAcademicYear($academicYearId: ID!) {
    getClassesByAcademicYear(academicYearId: $academicYearId) {
      _id
      className
    }
  }
`;

export const GET_STUDENT_ENROLLMENT_FOR_INVOICE = gql`
query GetStudentEnrollmentForInvoice($studentId: ID!, $academicYearId: ID!, $programId: ID!) {
  getStudentEnrollmentForInvoice(studentId: $studentId, academicYearId: $academicYearId, programId: $programId) {
    enrollmentId
    className
    gradeName
    classId
    gradeId
    shiftId
    shiftName
  }
}
`;

export const GET_INCOMESHIFT_BY_DATE = gql`
  query GetIncomeShift($fromDate: String, $toDate: String) {
    getIncomeShift(fromDate: $fromDate, toDate: $toDate) {
      _id
      shiftDate
      openTime
      closeTime
    }
  }
`;

export const SELECT_MAIN_USER = gql`
  query GetMainUserWithPagination(
    $page: Int
    $limit: Int
    $pagination: Boolean
    $keyword: String
  ) {
    getMainUserWithPagination(
      page: $page
      limit: $limit
      pagination: $pagination
      keyword: $keyword
    ) {
      data {
        _id
        user_id
        imageSrc
        email
        isDisabled
        firstName
        lastName
        latinName
        gender
        role
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;


export const GET_CUSTOMER = gql`
query GetAllCustomerOfGeneralInvoice {
  getAllCustomerOfGeneralInvoice {
    customerNameLatin
    customerNameKhmer
    _id
    companyName 
    type
    terms
    phone
    note
    gender
    email
    address
  }
}`;

export const GET_STUDENTS = gql`
query GetStudents($keyword: String) {
  getStudents(keyword: $keyword) {
    englishName
    firstName
    lastName
    _id
  }
}`;



export const GET_STUDENTS_BY_ACADEMIC_YEAR = gql`
query GetStudentByAcademicYearWeb($academicYearId: ID) {
  getStudentByAcademicYearWeb(academicYearId: $academicYearId) { 
    lastName
    firstName
    _id
    father {
      _id
      tel
      firstName
      lastName
      englishName
    }
    mother {
      _id
      firstName
      lastName
      tel
      gender
      englishName
    }
    guardian {
      _id
      firstName
      lastName
      englishName
      tel
    }
    gender
    englishName
    dob
    student_id
  }
}

`;



export const GET_SCHOOL = gql`
  query GetSchools {
    getSchools {
      _id
      schoolName
    }
  }
`;


export const SELECT_ACADEMIC_TERMS = gql`
query GetAcademicTerms($keyword: String) {
  getAcademicTerms(keyword: $keyword) {
    _id
    programId {
      programmNameEn
      programmName
    }
  }
}
`;

export const ITEM_FOR_SELECT = gql` 
query ItemsForSelect {
  itemsForSelect {
    _id
    itemName
    itemDescription
    incomeType
    createdAt
    updatedAt
  }
}`;

export const GET_DISCOUNT_FOR_SELECT = gql`
query GetDiscountForSelect {
  getDiscountForSelect {
    _id
    title
    amount
    note
  }
}`;

export const GET_ACADEMIC_TERMS_BY_ACADEMIC_YEAR_FOR_SELECT = gql`
query GetAcademicTermsByAcademicYearForSelete($academicYearId: ID!) {
  getAcademicTermsByAcademicYearForSelete(academicYearId: $academicYearId) {
    _id
    academicTermTitle
    endDate
    startDate
  }
}
`;


export const GET_QUARTER_BY_ACADEMIC_TERM_FOR_SELECT = gql`
query GetQuarterByAcademicTermsForSelete($academicTermId: ID!) {
  getQuarterByAcademicTermsForSelete(academicTermId: $academicTermId) {
    _id
    quarterName 
    endDate
    startDate
  }
}
`;


export const GET_INCOME_HEADS = gql`
query GetIncomeHeads {
  getIncomeHeads {
    _id
    note
    unit
    price
    incomeType
    incomeHead
  }
}`;

export const GET_PAYMENT_ALL_TYPE = gql`
query Query {
  getTypeOfPayment
}
`